import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Form as BootstrapForm } from "react-bootstrap";
import "../style/Login.css";

const Login = () => {
  const initialValues = {
    username: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required"),
  });

  const handleSubmit = (values) => {
    console.log("Login successful!");
    console.log(values);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form className="login-form">
            <BootstrapForm.Group>
              <BootstrapForm.Label className="form-label">
                Username
              </BootstrapForm.Label>
              <Field
                type="text"
                name="username"
                className={
                  "form-control" +
                  (errors.username && touched.username ? " is-invalid" : "")
                }
              />
              <ErrorMessage
                name="username"
                component="div"
                className="invalid-feedback"
              />
            </BootstrapForm.Group>

            <BootstrapForm.Group>
              <BootstrapForm.Label className="form-label">
                Password
              </BootstrapForm.Label>
              <Field
                type="password"
                name="password"
                className={
                  "form-control" +
                  (errors.password && touched.password ? " is-invalid" : "")
                }
              />
              <ErrorMessage
                name="password"
                component="div"
                className="invalid-feedback"
              />
            </BootstrapForm.Group>

            <Button type="submit" variant="primary" className="submit-button">
              <a href="/">Login</a>
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Login;
